export interface NavLinkItem {
  label: string
  to: string
}

export const navLinks: NavLinkItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Why', to: '/why' },
  { label: 'Why Viridia', to: '/why-viridia' },
  { label: 'Services', to: '/services' },
  { label: 'Book', to: '/book' },
]
